import { createSelector } from "reselect";
import _ from "lodash";
export const selectAllQualifications = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.qualifications;
};
export const selectPostFail = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.postFail;
};
export const selectPostSuccess = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.postSuccess;
};
export const selectQualSelectedTablePage = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.qualSelectedTablePage;
};
export const selectQualAvailableTablePage = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.qualAvailableTablePage;
};
export const selectQualAvailableTableRow = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.qualAvailableTableRow;
};
export const selectQualSelectedTableRow = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.qualSelectedTableRow;
};
export const selectQualEditModalInfo = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.qualEditModalInfo;
};
export const selectQualCategories = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.qualCategories;
};
export const selectQualsAvailableSelectedCategory = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.qualsAvailableSelectedCategory;
};
export const selectQualsSelectedSelectedCategory = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.qualsSelectedSelectedCategory;
};
export const selectQualAddModalInfo = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.qualAddModalInfo;
};
export const selectAllUsers = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.allUsers;
};
export const selectRequiredQualifications = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.requiredQualifications;
};
export const selectDeleteModalInfo = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.deleteModalInfo;
};
export const selectPostingQualifications = ({ QualificationsManager_reducer }) => {
    return QualificationsManager_reducer.deletingQualifications;
};
export const selectSelectedQualifications = createSelector(
    [selectAllQualifications, selectQualsSelectedSelectedCategory],
    (qualifications = false, category = "all_categories") => {
        if (qualifications) {
            let selectedQualifications = Object.keys(qualifications).map(e => {
                if (_.get(qualifications[e], "qualification_selected")) {
                    return qualifications[e];
                } else {
                    return null;
                }
            });
            if (category === "all_categories") {
                return _.compact(_.orderBy(selectedQualifications, "qualification_category"));
            } else {
                return _.compact(selectedQualifications).filter(e => {
                    if (e.qualification_category === category) return e;
                    else return null;
                });
            }
        } else {
            return false;
        }
    }
);
export const selectUnselectedQualifications = createSelector(
    [selectAllQualifications, selectQualsAvailableSelectedCategory],
    (qualifications = false, category = "all_categories") => {
        if (qualifications) {
            let unselectedQualifications = Object.keys(qualifications).map(e => {
                if (!_.get(qualifications[e], "qualification_selected")) {
                    return qualifications[e];
                } else {
                    return null;
                }
            });
            if (category === "all_categories") {
                return _.compact(_.orderBy(unselectedQualifications, "qualification_category"));
            } else {
                return _.compact(unselectedQualifications).filter(e => {
                    if (e.qualification_category === category) return e;
                    else return null;
                });
            }
        } else {
            return false;
        }
    }
);
